import { Layers } from "appworks/graphics/layers/layers";
import { AutoLossLimitRadioControl } from "appworks/ui/controls/standard/radio/auto-loss-limit-radio-control";
import { AutoRadioControlFactory } from "./auto-radio-control-factory";

export class AutoLossLimitRadioControlFactory extends AutoRadioControlFactory {

    constructor(protected trailingDecimals: boolean = true) {
        super();
    }

    public filter(layer: Layers) {
        if (layer.getFlexiButton("loss_limit_radio_1") && layer.getFlexiText("loss_limit_radio_1_label")) {
            return true;
        }

        return false;
    }

    public build(layer: Layers) {
        const data = this.getButtonsAndLabels(layer, "loss_limit");

        return [new AutoLossLimitRadioControl(
            data.buttons,
            data.labels,
            layer.getFlexiButton("loss_limit_radio_left"),
            layer.getFlexiButton("loss_limit_radio_right"),
            this.trailingDecimals
        )];
    }
}
